import { IStatisticSchema } from './statistic-schema.interface';

export interface IPunctualityStatisticSchema extends Omit<IStatisticSchema, 'difference'> {
    difference: number;
}

export interface IOperationalPunctualitySchema {
    onTimeLoadCheckpoints: IPunctualityStatisticSchema;
    onTimeUnloadCheckpoints: IPunctualityStatisticSchema;
    drilldown?: IOperationalPunctualityDrilldownSchema;
}

export interface IOperationalPunctualityDrilldownSchema {
    topDelayedEntities?: IOperationalPunctualityEntityItemSchema[];
    topDelayedLoadLocations?: IOperationalPunctualityLocationRankingItemSchema[];
    topDelayedUnloadLocations?: IOperationalPunctualityLocationRankingItemSchema[];
}

export interface IOperationalPunctualityLocationRankingItemSchema {
    locationId: string;
    location: string;
    lateTripsCount: number;
    averageDelayMinutes: string;
    averageDelayMinutesValue: number;
    targetEntities: IOperationalPunctualityEntityByLocationItemSchema[];
}

export interface IOperationalPunctualityEntityByLocationItemSchema {
    id: string;
    entityName: string;
    contact: string;
    lateTripsCount: number;
    totalTripCount: number;
    excludedTripCount: number;
    averageDelayMinutes: string;
    averageDelayMinutesValue: number;
    tripCodes: string[];
    tripDelays: IOperationalPunctualityTripDelayItemSchema[];
}

export interface IOperationalPunctualityEntityItemSchema {
    id: string;
    entityName: string;
    contact: string;
    averageLoadDelay: string;
    averageLoadDelayMinutes: number;
    averageUnloadDelay: string;
    averageUnloadDelayMinutes: number;
    topLoadLocations: IOperationalPunctualityLocationItemSchema[];
    topUnloadLocations: IOperationalPunctualityLocationItemSchema[];
}

export interface IOperationalPunctualityLocationItemSchema {
    locationId: string;
    location: string;
    lateTripsCount: number;
    totalTripCount: number;
    excludedTripCount: number;
    averageDelayMinutes: string;
    tripCodes: string[];
    tripDelays: IOperationalPunctualityTripDelayItemSchema[];
}

export interface IOperationalPunctualityTripDelayItemSchema {
    tripCode: string;
    averageDelayMinutes: string;
    delaySamples: IOperationalPunctualityTripDelaySampleItemSchema[];
}

export interface IOperationalPunctualityTripDelaySampleItemSchema {
    delayMinutes: string;
    isOutlier: boolean;
}
